import { getUserManager } from 'features/Security/utils';
import React, { FunctionComponent } from 'react';
import { UserManager, User } from 'oidc-client';
import { useHistory, useLocation, Redirect } from 'react-router';
import Loader from 'components/Loader';

export const AuthContext = React.createContext(undefined as any);


export interface AuthProviderProps {
    onLoggedIn?: (user: any) => void
}

export const AuthProvider: FunctionComponent<any> = (props: React.PropsWithChildren<AuthProviderProps>) => {
    const location = useLocation();
    const history = useHistory();
    const [isLoading, setIsLoading] = React.useState(true);
    const [userData, setUserData] = React.useState<User | null>(null);
    const [userManager] = React.useState<UserManager>(getUserManager());
    const isMountedRef = React.useRef(true);

    React.useEffect(() => {
        const checkLogInStatus = async () => {
            if (hasCodeInUrl(location)) {
                const user = await userManager.signinRedirectCallback();
                setUserData(user);
                setIsLoading(false);
                props.onLoggedIn && props.onLoggedIn(user)
                if (user && user.state) {
                    history.push(user.state)
                } else {
                    history.push("/")
                }
                return;
            }
            const user = await userManager?.getUser();
            if ((!user || user.expired)) {
                await userManager.signinRedirect({ state: location });
            } else if (isMountedRef.current) {
                props.onLoggedIn && props.onLoggedIn(user)
                setUserData(user);
                setIsLoading(false);
            }            
            return;
        }
        checkLogInStatus()

    }, [location]);

    React.useEffect(() => {
        const updateUserData = async () => {
            const user = await userManager.getUser();
            isMountedRef.current && setUserData(user);
        };
        userManager.events.addUserLoaded(updateUserData);
        return () => userManager.events.removeUserLoaded(updateUserData);
    }, [userManager]);

    return (
        <AuthContext.Provider value={{
            um: userManager,
            isLoading,
            logOut: async () => {
                setUserData(null);
                await userManager.signoutRedirect();
            },

        }}>
            {
                isLoading ?
                    <Loader />
                    :
                    props.children
            }
        </AuthContext.Provider>
    )

    function isLoggedIn() {

    }
}

export const hasCodeInUrl = (location: any): boolean => {
    
    const searchParams = new URLSearchParams(location.search);    
    let hash = "";
    if (location.hash !== undefined && location.hash != '')
    {
        hash = location.hash.replace('#', '?');
    }
    const hashParams = new URLSearchParams(hash);

    return Boolean(
        searchParams.get('code') ||
        searchParams.get('id_token') ||
        searchParams.get('session_state') ||
        hashParams.get('code') ||
        hashParams.get('id_token') ||
        hashParams.get('session_state'),
    );
};